<template>
  <div>
    <PCMenu :memberSystem="company"></PCMenu>
    <div class="banner">
<!--      <van-swipe v-if="company && company.extendInfo && company.extendInfo.banner.pc && !is116" class="my-swipe"-->
<!--       :autoplay="2000" >-->
<!--        <van-swipe-item v-for="(image, index) in company.extendInfo.banner.pc.split(',')" :key="index" >-->
<!--          <img class="w-100" :src="global.getStaticFilePath(image)" style="width:530px;height:325px"/>-->
<!--        </van-swipe-item>-->

<!--      </van-swipe>-->
        <div v-if="company && company.extendInfo && company.extendInfo.banner.pc && !is116" class="w1200  m-auto"
             :style="company&&company.memberSystemId==89?'flex-wrap: nowrap;justify-content: space-around;':''">

            <img v-for="(image, index) in company.extendInfo.banner.pc.split(',')" :key="index"
                 :src="global.getStaticFilePath(image)">
        </div>
      <div v-if="is116">
        <img src="@/assets/images/memberSystem116.png" width="1200" style=" height: calc(100vh - 80px);width: 100%;margin: auto;max-width: 100%;">
      </div>
    </div>
    <div class=" video m-auto w1200 m-t-30" v-if="!is116">
      <ul class="flex">
        <li v-if="company.memberSystemId!=89" @click="showVideo('https://cdn2.carziliao.com/wx/video/video-1.mp4')" class="m-r-20">
          <div class="playicon">
            <van-icon name="play"/>
          </div>
          <img src="@/assets/images/video-1.png">
          <div class="title">资料亮点</div>
        </li>
        <li v-if="company.memberSystemId!=89" @click="showVideo('https://cdn2.carziliao.com/wx/video/video-2.mp4')">
          <div class="playicon">
            <van-icon name="play"/>
          </div>
          <img src="@/assets/images/video-2.png">
          <div class="title">查阅问题</div>
        </li>
<!--        <li>-->
<!--          <dl class="newslist m-l-20 m-r-20">-->
<!--            <dt>公告 <span @click="$router.push({ path: '/pc/newslist' })">更多</span></dt>-->
<!--            <dd v-for="(news, index) in newsList.dataList" :key="index" @click="showNews(news.id)">{{ news.title }}-->
<!--              &lt;!&ndash;<span>05-08</span>&ndash;&gt;-->
<!--            </dd>-->
<!--          </dl>-->
<!--        </li>-->
      </ul>
    </div>
    <van-popup v-model="video.isShow"
               @closed="$router.push({ path: '/pc/choose/0' })" closeable style="padding-top:50px; background:none;"
               :style="{ height: '80%' }">
      <VideoModule style="height:95%" :video="video"></VideoModule>
    </van-popup>
    <!-- <div id="videotemplet">
      <VideoModule :video="video"></VideoModule>
    </div> -->
    <PCCopyright v-if="company.memberSystemId!=116"/>
  </div>
</template>

<script>
import PCMenu from "@/components/PCMenu.vue";
import PCCopyright from "@/components/PCCopyright.vue";
import VideoModule from "@/components/Video.vue";
import {
  Get_News_List,
  Wx_Bind,
  Check_Wx_Login,
  Refresh_Token,
} from "@/api/index";

import {
  Popup,
  NavBar,
  Image as VanImage,
  Icon,
  Swipe,
  SwipeItem,
  Grid,
  GridItem,
  NoticeBar,
  Tabbar,
  TabbarItem,
  Col,
  Row,
  Dialog,
} from "vant";

export default {
  name: "PcIndex",
  components: {
    PCMenu,
    PCCopyright,
    VideoModule,
    [Popup.name]: Popup,
    [Icon.name]: Icon,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
  },
  data() {
    return {
      video: {
        path: "",
        isShow: false,
      },
      company: {},
      newsList: [],
      is116: false
    };
  },
  methods: {
    showNews: function (id) {
      var that = this;
      layui.use(["layer", "form"], function () {
        var layer = layui.layer,
            form = layui.form;
        var title = that.newsList.dataList.find((m) => m.id == id).title;
        layer.open({
          type: 1,
          title: "公告",
          skin: "layui-layer-rim", //加上边框
          area: ["420px", "240px"], //宽高
          content: '<div style="padding:10px">' + title + "</div>",
        });
      });
    },
    showVideo: function (url) {
      this.video.path = url;
      this.video.isShow = true;
    },
  },
  async created() {
    // let memberSystemId = this.$route.query.memberSystemId;
    // if (memberSystemId == 116) {
    //   this.is116 = true
    //   this.fontSize = '22px'
    // }
  },
  async mounted() {
    let memberSystemId = this.$route.query.memberSystemId;
    if (!this.global.isNull(memberSystemId)) {
      await this.global.setMemberSystem(memberSystemId);
    }

    this.newsList = [];//await Get_News_List({page: 1, pageSize: 5});

    //api接口登陆过来的用户，需要重新获取一下用户信息
    let refreshToken = this.$route.query.RefreshToken;
    if (!this.global.isNull(refreshToken)) {
      this.global.refreshToken(refreshToken);
    }
    this.global.getMemberSystem().then((memberSystem) => {
      debugger
      if (!this.global.isNull(memberSystem)) {
        this.company = memberSystem;
        console.log(this.company);
        if (memberSystem.memberSystemId == 116) {
          this.is116 = true
        }
        if (this.company.type == 1&&!this.global.isMobile()) {
          this.$router.replace({path: "/choose/0"});
        }
      }
    });
  },
};
</script>
<style scoped>
/*.banner .flex{*/
/*  max-width: 100%;*/
/*  flex-wrap: nowrap;*/
/*  flex-direction: row;*/
/*  justify-content: space-around;*/
/*}*/
.banner .flex img {
  height:auto;
}
.my-swipe .van-swipe-item {
  color: #fff;
  text-align: center;
}
.my-swipe .van-swipe-item img{
  max-width:1200px;
}
</style>
